function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentsBadgedInactive = function SvgPaymentsBadgedInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26 9v22M31 13h-7.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H20",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 8,
    r: 6,
    fill: props.accentFill,
    stroke: "none"
  }));
};
export default SvgPaymentsBadgedInactive;